// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"814a7325","426":"4d26f459"}[chunkId] + ".chunk.css";
};